import { render, staticRenderFns } from "./TicketMessages.vue?vue&type=template&id=0f09a01b"
import script from "./TicketMessages.vue?vue&type=script&lang=js"
export * from "./TicketMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports